import React from "react";
import PropTypes from "prop-types";
import styles from "./CornerBadge.module.scss";

/* Corner Badge */
const CornerBadge = (props) => {

    return (
        <div className={styles.badge}>
            <div id="cornerBadge" className={styles.ribbon +" "+ props.class}>{props.label}</div>
        </div>
    );
}

CornerBadge.defaultProps = {
    label: "BETA",
    class: "text-white bg-green"
}

CornerBadge.propTypes = {
    label: PropTypes.string,
    class: PropTypes.string
}

export default CornerBadge;